import React from "react";
import { useState, useEffect } from "react";

import { Link, useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Grid,
  Tabs,
  Tab,
  CircularProgress,
  Stack,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
} from "@mui/material";

import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";
import {
  revFairValueFormulaTable,
  revRecognitionPlanTable,
} from "../../../config/grid-column-defs";
import useSnackbar from "../../../hooks/useSnackbar";
import { useSelector } from "react-redux";
import { getTransactionNotAvailable } from "../../../config/grid-value-formatters";
import { GridComp4 } from "../../../components/GridComponents";
import { CustomCheckBox } from "../../../components/CheckboxComp";
import TabPanel from "../../../components/TabPanel";
import { slugMap } from "../../../config/slug-config";
import {
  getTransactionRevArrangRevenueFairValueFormula,
  getTransactionRevArrangRevenueFairValueFormulaSytemNotes,
} from "../../../api/transaction-type";

export default function FairValueFormula() {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  console.log("fvf====", params.FVF);
  const pageDetail = slugMap[params.slug];

  // const [tableRefreshCount, setTableRefreshCount] = useState(0);
  // function refreshTable () {
  //     setTableRefreshCount(prev => prev + 1);
  // }

  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(false);

  /*----------------Tabs-----------------*/
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (user.token) {
      getTransactionRevenueArrangementFVFData();
    }
  }, []);

  async function getTransactionRevenueArrangementFVFData() {
    setLoading(true);
    try {
      const { data } = await getTransactionRevArrangRevenueFairValueFormula(
        user.token,
        {
          formula_name: params.FVF,
        }
      );
      setRowData(data.data.data);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }
  async function getTransactionRevenueArrangementFVFSystemNotesTableData(
    limit,
    offset
  ) {
    setLoading(true);
    try {
      const { data } =
        await getTransactionRevArrangRevenueFairValueFormulaSytemNotes(
          user.token,
          {
            formula_name: params.FVF,
            limit,
            offset,
          }
        );
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }
  return (
    <>
      {/*Primary Information*/}
      <Typography component="h4" fontWeight={500} className="pageTitle">
        Fair Value Formula
      </Typography>
      <Typography component="p" sx={{ mb: 6 }} className="m-b-10">
        {rowData.map((d, i) => (
          <>
            <strong>{d.tranid}</strong> {d.customer}
          </>
        ))}
      </Typography>
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          {rowData.map((d, i) => (
            <>
              <Grid container className="mb-2">
                <GridComp4 title={"NAME"} data={d.name} />
                <GridComp4
                  title={"FAIR VALUE FORMULA"}
                  data={d.fair_value_formula}
                />
                <GridComp4 title={"DESCIPTION"} data={d.description} />

                <CustomCheckBox title={"INACTIVE"} data={d.inactive} />
              </Grid>
            </>
          ))}
        </Box>
      </Box>

      <Box>
        <Tabs
          value={tabIndex}
          // onChange={handleChange}
          onChange={(e, nv) => {
            setTabIndex(nv);
          }}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          className="tabs-bkg tabs-spacing"
        >
          <Tab label="SYSTEM NOTES" />
        </Tabs>

        <TabPanel value={tabIndex} index={0}>
          <Box
            className="viewBox sub-tab"
            sx={{
              maxWidth: { xs: 320, sm: 480, md: "100%" },
              bgcolor: "#fff",
            }}
          >
            <br />
            <Grid container spacing={2} p={1}>
              <Grid item xs={12} sm={4} md={3}>
                <FormControl fullWidth size="small">
                  <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value=""
                    label="VIEW"
                  >
                    <MenuItem value="Default View">Default View</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4} md={3}>
                <FormControl fullWidth size="small">
                  <InputLabel id="demo-simple-select-label">FIELD</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value=""
                    label="FIELD"
                  >
                    <MenuItem value="Default View">Default View</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            <AgGridPaginatedTable
              getTableRows={
                getTransactionRevenueArrangementFVFSystemNotesTableData
              }
              columns={revFairValueFormulaTable}
              perPage={2}
              refreshCounter={0}
            />
          </Box>
        </TabPanel>
        {/* Revenue Elements */}
      </Box>
    </>
  );
}
